module.exports = __webpack_public_path__ + "static/img/csn.83702571.svg";